/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { memo, ReactElement } from 'react';
import { TableBody, TableRow, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Incapacitated, ListTableColumnConfig } from './ListTypes';
import ListTableRowContent from './ListTableRowContent';
import { createListStyles } from './ListStyles';

interface ListTableBodyProps<T extends object> {
    columns: ListTableColumnConfig<T>[];
    data: T[];
    rowsToAnimate?: number[];
    getColorBarProps?(status: unknown): { color: string; height: number; tooltipTranslatePrefix: string };
    getColoredValue?(value: unknown, key?: unknown): { color: string; text: string };
    getCustomCellContent?(index: number, columnKey: string, row: number): ReactElement;
    onClick?(columnKey: string, row: number): void;
}

const ListTableBody = <T extends object>(props: ListTableBodyProps<T>) => {
    const ListStyles = makeStyles((theme: Theme) => createStyles(createListStyles(theme)));
    const classes = ListStyles();
    const { columns, data, rowsToAnimate, getColorBarProps, getColoredValue, getCustomCellContent, onClick } = props;

    return (
        <>
            {data.length !== 0 ? (
                <TableBody>
                    {data.map((item, itemIndex) => {
                        return (
                            <TableRow
                                key={itemIndex}
                                className={
                                    //add these classes to VirtuosoTableComponents(TableRow) if there are rowsToAnimate or incapacitated items
                                    rowsToAnimate && rowsToAnimate.includes(itemIndex)
                                        ? classes.rowAnimation
                                        : (item as Incapacitated).incapacitated
                                          ? classes.incapacitatedRow
                                          : null
                                }
                                hover
                            >
                                <ListTableRowContent
                                    columns={columns as ListTableColumnConfig<object>[]}
                                    item={item}
                                    itemIndex={itemIndex}
                                    getColorBarProps={getColorBarProps}
                                    getColoredValue={getColoredValue}
                                    getCustomCellContent={getCustomCellContent}
                                    onClick={onClick}
                                />
                            </TableRow>
                        );
                    })}
                </TableBody>
            ) : null}
        </>
    );
};

export default memo(ListTableBody);
